// ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, pageId }) => {
  const storedUser = JSON.parse(sessionStorage.getItem("userData"));

  // 🚫 Not Logged In
  if (!storedUser) {
    return <Navigate to="/" replace />;
  }

  // ✅ ADMIN → Full Access
  if (storedUser.login_type === "ADMIN") {
    return children;
  }

  // 👤 USER → Check Permission
  if (storedUser.login_type === "USER") {
    // If no pageId (like dashboard), allow
    if (!pageId) return children;

    const hasPermission = storedUser.menus?.some((menu) =>
      menu.pages?.some(
        (page) =>
          page.page_id === pageId &&
          ( page.is_view === 1 ||
            page.is_new === 1 ||
            page.is_edit === 1 ||
            page.is_delete === 1)
      )
    );

    if (!hasPermission) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;